<template>
  <div class="container">
    <h1>Sorry, you're not permitted access to this page.</h1>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    msg: String
  },
  computed: {},
  updated() {},
  methods: {}
};
</script>

<style scoped lang="stylus">
  h1{
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.25rem;
  }
  .container {
    text-align: center;
    color: #555;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
